module.exports = __webpack_public_path__ + "img/1.991c68ac.jpg";